import React from "react";
import { Button } from "../../atoms/button";
import get from "lodash/get";
import NewsLetterConfig from "../../../../../config/newsletter";

import "./stop-press.m.css";

const StopPress = ({ collection, planName }) => {  
  const { subscriptionData } = NewsLetterConfig();
  const name = get(collection, ["associated-metadata", "name"], "Stop Press");
  const getPlanName = planName || name
  const getPlanDetails = subscriptionData.filter(item => item.title == getPlanName) || [];

  return getPlanDetails.length> 0 && (
    <div styleName="stop-process-container">
      <h3 styleName="stop-process">
        <span styleName="stop">{getPlanDetails[0].title}</span> 
      </h3>
      <p styleName="description">{getPlanDetails[0].description}</p>
      <div styleName="subcribe-bottom">
        <Button href={`/newsletter-signup?${decodeURIComponent(getPlanDetails[0].title)}`}>Sign&nbsp;Up</Button>
      </div>
    </div>
  );
};

export default StopPress;
